import React from 'react';
import { bool, func } from 'prop-types';
import { ShipmentInAccordance } from '@magalu/stereo-ui-icons';
import { Box, Flex } from '../../atoms';
import { ImportText, Disclaimer, ImportButton, DialogHorizontalRule } from './import-taxes.styles';

const ImportDetails = ({
  closeDetails,
  isMobile
}) => {
  return /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    "data-testid": "detail-text"
  }, /*#__PURE__*/React.createElement(Box, {
    p: 16
  }, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: isMobile ? 'column' : 'row'
  }, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(ShipmentInAccordance, {
    mr: 16,
    width: 66,
    height: 67
  })), /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Disclaimer, null, "[PRODUTO INTERNACIONAL/COMPRA INTERNACIONAL] Toda mercadoria proveniente do exterior (importada) deve ser objeto de declara\xE7\xE3o de importa\xE7\xE3o e est\xE1 sujeita a tributos federal e estadual."))), /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(ImportText, null, /*#__PURE__*/React.createElement("span", null, "Com o Remessa Conforme, o programa do governo brasileiro que simplifica o processo de importa\xE7\xE3o, voc\xEA sabe de forma clara o que pagar:"), /*#__PURE__*/React.createElement("span", null, "\u2022 Para compras ", /*#__PURE__*/React.createElement("b", null, "at\xE9 50 d\xF3lares"), ", voc\xEA paga 20% de taxa de importa\xE7\xE3o e o ICMS*, sem taxas extras na alf\xE2ndega."), /*#__PURE__*/React.createElement("span", null, "\u2022 Para compras ", /*#__PURE__*/React.createElement("b", null, "acima de 50,01 d\xF3lares"), ", a taxa de importa\xE7\xE3o \xE9 de 60%, com um desconto de 20 d\xF3lares, al\xE9m do ICMS*. E n\xE3o h\xE1 taxas extras na alf\xE2ndega."), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, "*ICMS:"), " Imposto estadual sobre a circula\xE7\xE3o de produtos e servi\xE7os no Brasil. Al\xEDquota de 17% ou 20% calculada automaticamente de acordo com o estado de destino da mercadoria. Em caso de d\xFAvidas sobre a al\xEDquota consulte a Secretaria da Fazenda do seu estado.")))), /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "center",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(DialogHorizontalRule, {
    ruleSize: 1,
    bg: "border.light"
  }), /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(ImportButton, {
    onClick: closeDetails
  }, "Entendi"))));
};

process.env.NODE_ENV !== "production" ? ImportDetails.propTypes = {
  closeDetails: func,
  isMobile: bool
} : void 0;
ImportDetails.defaultProps = {
  closeDetails: () => {},
  isMobile: false
};
export default ImportDetails;